import I18n from 'lib/i18n'
import './styles.scss'

import React from 'react'

const Share = ({ withText, onClick }) => (
  <div className='generic-share-button' onClick={onClick}>
    <svg stroke='#c4c4c4' viewBox='3 3 19 19' focusable='false' className='generic-share'>
      <path d='M14 9V5l7 7-7 7v-4.1c-5 0-8.5 1.6-11 5.1 1-5 4-10 11-11z' />
    </svg>
    {withText && <div>{I18n.t('courses.show.share_button')}</div>}
  </div>
)

export default Share
